import { render } from "./dataBoxes.vue?vue&type=template&id=6ce83d01"
import script from "./dataBoxes.vue?vue&type=script&lang=js"
export * from "./dataBoxes.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__